<template>
  <!--Footer Section-->
  <footer class="footer-section">
    <div class="container-fluid">
      <div class="footer-wrapper">
        <div class="footer-top" v-if="false">
          <ul class="footer-link-left">
            <!-- <li>
              <router-link to="/terms">{{ $t('Term of use') }}</router-link>
            </li>
            <li>
              <router-link to="/privacy">{{ $t('Privacy policy') }}</router-link>
            </li> -->
            <!-- <li>
              <a href="contact.html"> Help center </a>
            </li>
            <li>
              <a href="contact.html"> Provably fair </a>
            </li> -->
          </ul>
          <ul class="footer-right-social">

          </ul>
        </div>
        <div class="footer-bootm">
          <p>
            {{ $t("Copyright") }} {{ currentYear }} &copy; {{ $t("All Rights Reserved") }} | {{ $t('Powered By Three Hundred Sixty') }}.
          </p>
        </div>
      </div>
    </div>
  </footer>
  <!--Footer Section-->
</template>

<script>
export default {
  name: "FooterComponent",
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>
